import { demo as en_demo } from "../en/demo";

/** demo — ES slice. */
export const demo: Record<keyof typeof en_demo, string> = {
  // App shell / header
  demo_app_title: "Mini App de demostración",
  demo_status_connected: "Conectado",
  demo_status_disconnected: "Desconectado",
  demo_config_version: "{name} v{version}",

  // Console
  demo_console_title: "Consola",
  demo_console_clear: "Limpiar",
  demo_console_empty: "Aún no hay registros...",

  // Bridge lifecycle logs
  demo_bridge_initializing: "Inicializando el puente...",
  demo_bridge_connected: "¡Puente conectado!",
  demo_bridge_config_loaded: "Configuración cargada: {name} v{version}",
  demo_bridge_config_failed: "No se pudo obtener la configuración: {error}",
  demo_bridge_user_loaded: "Usuario cargado: {userId}",
  demo_bridge_user_failed: "No se pudo obtener el usuario: {error}",
  demo_bridge_user_updated: "Usuario actualizado",
  demo_bridge_init_failed: "Falló la inicialización del puente: {error}",
  demo_bridge_logs_cleared: "Registros borrados",

  // User section
  demo_user_title: "Contexto del usuario",
  demo_user_result_placeholder: "Pulsa un botón para ver los resultados...",
  demo_user_get_info: "Obtener info del usuario",
  demo_user_get_token: "Obtener token de auth",
  demo_user_log_get_info: "Llamando a user.getInfo()...",
  demo_user_log_info_retrieved: "Info del usuario obtenida",
  demo_user_log_get_info_error: "Error de getUserInfo: {error}",
  demo_user_log_get_token: "Llamando a user.getAuthToken()...",
  demo_user_log_token_retrieved: "Token de auth obtenido",
  demo_user_log_get_token_error: "Error de getAuthToken: {error}",

  // Modal section
  demo_modal_title: "Control del modal",
  demo_modal_default_title: "Título personalizado",
  demo_modal_title_placeholder: "Escribe un título...",
  demo_modal_set_title: "Definir título",
  demo_modal_full_height: "Altura completa",
  demo_modal_half_height: "Media altura",
  demo_modal_close: "Cerrar modal",
  demo_modal_close_message: "Cerrado desde la demo",
  demo_modal_log_set_title: 'Definiendo el título del modal: "{title}"...',
  demo_modal_log_title_set: "Título definido",
  demo_modal_log_set_title_error: "Error de setModalTitle: {error}",
  demo_modal_log_set_full: "Definiendo altura: completa...",
  demo_modal_log_full_set: "Altura definida en completa",
  demo_modal_log_set_half: "Definiendo altura: media...",
  demo_modal_log_half_set: "Altura definida en media",
  demo_modal_log_set_height_error: "Error de setModalHeight: {error}",
  demo_modal_log_closing: "Cerrando el modal...",
  demo_modal_log_close_error: "Error de closeModal: {error}",

  // Toast & Alerts section
  demo_toast_title: "Toasts y alertas",
  demo_toast_success: "Éxito",
  demo_toast_error: "Error",
  demo_toast_warning: "Advertencia",
  demo_toast_info: "Info",
  demo_toast_alert: "Alerta",
  demo_toast_destructive: "Destructiva",
  demo_toast_message_success: "¡Operación exitosa!",
  demo_toast_message_error: "¡Algo salió mal!",
  demo_toast_message_warning: "¡Ten cuidado!",
  demo_toast_message_info: "Aquí tienes algo de información.",
  demo_toast_log_showing: "Mostrando toast de {type}...",
  demo_toast_log_shown: "Toast mostrado",
  demo_toast_log_show_error: "Error de showToast: {error}",
  demo_alert_title: "Alerta de demostración",
  demo_alert_message: "¿Seguro que quieres continuar con esta acción?",
  demo_alert_confirm: "Confirmar",
  demo_alert_cancel: "Cancelar",
  demo_alert_log_showing: "Mostrando el diálogo de alerta...",
  demo_alert_log_result_confirmed: "Resultado de la alerta: Confirmado",
  demo_alert_log_result_cancelled: "Resultado de la alerta: Cancelado",
  demo_alert_log_error: "Error de showAlert: {error}",
  demo_alert_destructive_title: "Eliminar elemento",
  demo_alert_destructive_message:
    "Esta acción no se puede deshacer. ¿Estás seguro?",
  demo_alert_destructive_confirm: "Eliminar",
  demo_alert_destructive_log_showing: "Mostrando la alerta destructiva...",
  demo_alert_destructive_log_result_deleted:
    "Resultado de la alerta destructiva: Eliminado",
  demo_alert_destructive_log_result_cancelled:
    "Resultado de la alerta destructiva: Cancelado",
  demo_alert_destructive_log_error: "Error de showDestructiveAlert: {error}",

  // Storage section
  demo_storage_title: "Almacenamiento",
  demo_storage_result_placeholder:
    "Los resultados del almacenamiento aparecerán aquí...",
  demo_storage_default_value: "¡Hola desde la Mini App!",
  demo_storage_key_placeholder: "Escribe una clave...",
  demo_storage_value_placeholder: "Escribe un valor...",
  demo_storage_set: "Guardar",
  demo_storage_get: "Obtener",
  demo_storage_remove: "Eliminar",
  demo_storage_log_setting: "Guardando en almacenamiento: {key} = {value}...",
  demo_storage_log_set: "Elemento guardado en almacenamiento",
  demo_storage_log_set_error: "Error de setStorageItem: {error}",
  demo_storage_log_getting: "Obteniendo de almacenamiento: {key}...",
  demo_storage_log_retrieved: "Elemento de almacenamiento obtenido",
  demo_storage_log_get_error: "Error de getStorageItem: {error}",
  demo_storage_log_removing: "Eliminando de almacenamiento: {key}...",
  demo_storage_log_removed: "Elemento de almacenamiento eliminado",
  demo_storage_log_remove_error: "Error de removeStorageItem: {error}",

  // API section
  demo_api_title: "Proxy de API",
  demo_api_result_placeholder: "Los resultados de la API aparecerán aquí...",
  demo_api_call: "Hacer llamada a la API",
  demo_api_log_calling: "API: {method} {endpoint}...",
  demo_api_log_success: "Llamada a la API exitosa ({status})",
  demo_api_log_error: "Error de apiCall: {error}",

  // Permissions section
  demo_permissions_title: "Permisos",
  demo_permissions_result_placeholder:
    "Los resultados de los permisos aparecerán aquí...",
  demo_permissions_request_camera: "Solicitar cámara",
  demo_permissions_request_files: "Solicitar archivos",
  demo_permissions_request_location: "Solicitar ubicación",
  demo_permissions_request_notifs: "Solicitar notif.",
  demo_permissions_check_camera: "Verificar cámara",
  demo_permissions_get_all: "Obtener todos",
  demo_permissions_log_requesting: "Solicitando permiso: {permission}...",
  demo_permissions_log_granted: "Permiso concedido",
  demo_permissions_log_denied: "Permiso denegado",
  demo_permissions_log_request_error: "Error de requestPermission: {error}",
  demo_permissions_log_checking: "Verificando permiso: {permission}...",
  demo_permissions_log_check_granted: "Permiso {permission}: concedido",
  demo_permissions_log_check_not_granted: "Permiso {permission}: no concedido",
  demo_permissions_log_check_error: "Error de hasPermission: {error}",
  demo_permissions_log_getting_all: "Obteniendo todos los permisos...",
  demo_permissions_log_got_all: "Se obtuvieron {count} permisos",
  demo_permissions_log_get_all_error: "Error de getPermissions: {error}",

  // Haptics section
  demo_haptics_title: "Vibración háptica",
  demo_haptics_light: "Ligera",
  demo_haptics_medium: "Media",
  demo_haptics_heavy: "Fuerte",
  demo_haptics_success: "Éxito",
  demo_haptics_error: "Error",
  demo_haptics_warning: "Advertencia",
  demo_haptics_log_triggering: "Activando vibración háptica: {type}...",
  demo_haptics_log_triggered: "Vibración háptica activada",
  demo_haptics_log_error: "Error de triggerHaptic: {error}",
};
